import React, { useEffect, useState } from 'react';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card } from '../UI';

export default function RiderPerformance() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(`${Endpoints.ANALYTICS_RIDER_PERFORMANCE}?limit=50`)
      .then((r) => r.json())
      .then((res) => {
        setRows((res && res.data) || res || []);
        setLoading(false);
      });
  }, []);

  const columns = [
    { name: 'Name', selector: 'name' },
    { name: 'Completed', selector: 'completed_jobs', sortable: true },
    { name: 'Hours (7d)', cell: (row) => (row.hours_online || 0).toFixed(1), sortable: true, selector: 'hours_online' },
    { name: 'Rating', cell: (row) => (row.average_rating || 0).toFixed(2) },
    { name: 'On-time %', cell: (row) => `${(row.on_time_percent || 0).toFixed(1)}%` },
    { name: 'Complaints', selector: 'complaint_count' },
    { name: 'Score', cell: (row) => (row.score || 0).toFixed(2), sortable: true },
  ];

  return (
    <PageLayout title="Rider performance">
      <Card padded={false}>
        <DataTable columns={columns} data={rows} progressPending={loading} pagination paginationPerPage={20} noHeader={true} />
      </Card>
    </PageLayout>
  );
}
